module.exports = __webpack_public_path__ + "static/home-logos-0237d445b26605c054fbdc98d5c2a0e4.png";